// Modified by AI on 05/13/2026. Edit #1.
export const RoutePaths = Object.freeze({
    editEmployer: '/employer/:employerId/editEmployer',
    editAdvancedSettings: '/employer/:employerId/editEmployer/defaultAssociatedEmployersSettings',
    employerPositions: '/employer/:employerId/positions',
    noAccessPage: '/no-access-page',
    talenyaCreateRecruiter: '/talenya/createRecruiter',
    fastRatingPage: '/employer/:employerId/position/:positionId/wizard/preliminaryFeedback/v2',
    fastRatingSuggestionsPage: '/employer/:employerId/position/:positionId/wizard/suggestions',
    employerJobCandidatesPage: '/employer/:employerId/position/:positionId/workflowStep/:workflowStep/candidates',
    employerJobCandidateProfile: '/employer/:employerId/position/:positionId/workflowStep/:workflowStep/candidates/:talentId',
    employerJobCandidateProfileReviewTab: '/employer/:employerId/position/:positionId/workflowStep/Feedback/candidates/:talentId',
    instantRating: '/employer/:employerId/position/:positionId/wizard/instantRating',
    manualQualify: '/employer/:employerId/position/:positionId/wizard/manualQualify',
    manualSelectPage: '/employer/:employerId/position/:positionId/wizard/manualQualify/:talentId',
    employerPositionEdit: '/employer/:employerId/position/:positionId/wizard/edit',
    completeMessage: '/employer/:employerId/position/:positionId/wizard/completeMessage',
});
